export const OMAN_PRIORITY_RULES = Object.freeze({
  needsReviewMaxReviews: 4,
  highMinReviews: 631,
  highMinRating: 4.0,
  mediumMinReviews: 194,
  mediumMinRating: 3.8,
});

/**
 * Ratings are business values displayed at one decimal precision. Normalize
 * weighted aggregates at that boundary before applying unchanged thresholds;
 * this prevents binary floating-point artifacts such as 3.7999999999999994
 * from changing a 3.8 classification.
 */
export function normalizeOmanRating(rating) {
  const value = Number(rating);
  return Number.isFinite(value) ? Number(value.toFixed(1)) : 0;
}

export function calculateOmanPriority({ rating, user_rating_count, Reviews } = {}) {
  const reviews = Number(user_rating_count ?? Reviews);
  const stars = normalizeOmanRating(rating);
  if (!Number.isFinite(reviews) || reviews <= OMAN_PRIORITY_RULES.needsReviewMaxReviews) return "Needs Review";
  if (reviews >= OMAN_PRIORITY_RULES.highMinReviews && Number.isFinite(stars) && stars >= OMAN_PRIORITY_RULES.highMinRating) return "High";
  if (reviews >= OMAN_PRIORITY_RULES.mediumMinReviews && Number.isFinite(stars) && stars >= OMAN_PRIORITY_RULES.mediumMinRating) return "Medium";
  return "Low";
}

export function calculateOmanPriorityDistribution(rows) {
  return rows.reduce((counts, row) => {
    const priority = calculateOmanPriority(row);
    counts[priority] = (counts[priority] || 0) + 1;
    return counts;
  }, { High: 0, Medium: 0, Low: 0, "Needs Review": 0 });
}
